import React from 'react';
import { connect } from 'react-redux';
import { logInUser } from '../../actions/auth';
import { FORM_REFS } from '../../constants';
import { aemHostClient, eapiClient } from '../../restClient';
import { Translations, cryptoPass } from '../../utils';
import Dynamicform from '../common/Dynamicform/dynamicForm';
import Modal, { ModalBody, ModalFooter } from '../common/Modal';
import { getDarkTitleBarFlagOnPassword, setDarkTitleBarContent, setHeaderDetails, setTranslatedData } from '../layouts/actions/actionCreator';
import './first-time-user-password.css';

class FirstTimeUserCreateNewPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentDidMount() {
    aemHostClient('/aemData/formData/json_en-gb')
      .then(({ data }) => {
        this.props.setTranslatedData(data)
        /*===================Dark title bar page json =================*/
        aemHostClient("/aemData/formData/json_dark-title-bar")
          .then(({ data }) => {
            this.setState({ darkTitleBarJson: data.par });
            const title = data.par.static_text_darkTitleBar.createPassword;
            this.props.setDarkTitleBarContent(this.translations(title), false);
            document.title = `${this.translations(data.par.static_text_darkTitleBar.createPassword)} - ${'HSBC GLCM'}`;
          });
        aemHostClient("/aemData/formData/json_create-password")
          .then(({ data, status }) => {
            this.setState({ formJson: data });
          });

        //header login toNextpage
        aemHostClient('/aemData/formData/json_header-page')
          .then(({ data }) => {
            this.props.setHeaderDetails(Translations(data.par.static_text_darkTitleBar.lastLogin, this.props.lang.currentLang.lang, this.props.lang.translatedData),
              Translations(data.par.static_text_darkTitleBar.logOff, this.props.lang.currentLang.lang, this.props.lang.translatedData))
          })

        aemHostClient("/aemData/formData/json_passwordResetMessage")
          .then(({ data }) => {
            this.setState({ passwordResetMessage: data.par });
          });

      });

  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      console.log("11");
      this.props.getDarkTitleBarFlagOnPassword(1);
    }
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = async (data) => {
    var payLoad = {};
    if (this.state.formData && this.state.formData.newPassword !== undefined && this.state.formData.confirmPassword !== undefined) {
      if (this.state.formData.newPassword !== this.state.formData.confirmPassword) {
        this.setState({ pwdNotMatch: true });
      } else {
        this.setState({ pwdNotMatch: false });
        payLoad.password = await cryptoPass(this.state.formData.newPassword);

        eapiClient("/users/createNewPassword", {
          method: 'POST',
          timeout: 30000,
          data: JSON.stringify(payLoad)
        })
          .then(({ data, status, headers }) => {
            if (status === 200) {
              //const token = headers["openam-auth-token"];
              //const {userDetails, lastLogin} = data.responseData;
              //this.props.logInUser(true, token,  data.responseData.principal, new Date(), '/case-list');
              // this.props.history.push('/case-list');
              this.setState({ showPassWordResetInfoModal: true, responseReceived: data.responseStatus.serviceErrorCode === "" ? true : false })
            }
          })
          .catch((error) => {
            if (error && error.response && error.response.status === 401) {
              this.setState({ showUnAuthorised: true });
            }
          });
      }
    }
  }

  renderFormGroups() {
    let formData = {};
    const properties = {
      formData,
      editType: 'first-time-user',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_newPasswordForm !== undefined) {
      return (
        <Dynamicform
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_newPasswordForm.formRef]}
          getFormData={this.getFormData}
          disableSubmitOnClick={false}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
        />
      );
    }
  }

  togglePassWordResetInfoModal = () => {
    this.setState({ showPassWordResetInfoModal: false })
    this.props.history.push('/case-list');
  }

  closePasswordResetModal = () => {
    this.setState({ showPassWordResetInfoModal: false })
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.info_graphic_informationToHand.title : '';
    const pwdhint1 = this.state.formJson ? this.state.formJson.par.info_graphic_informationToHand.descriptionText1 : '';
    const pwdhint2 = this.state.formJson ? this.state.formJson.par.info_graphic_informationToHand.descriptionText2 : '';
    const pwdhint3 = this.state.formJson ? this.state.formJson.par.info_graphic_informationToHand.descriptionText3 : '';
    const pwdhint4 = this.state.formJson ? this.state.formJson.par.info_graphic_informationToHand.descriptionText4 : '';
    const pwdhint5 = this.state.formJson ? this.state.formJson.par.info_graphic_informationToHand.descriptionText5 : '';
    if (this.state.darkTitleBarJson !== undefined && this.state.formJson !== undefined && this.state.passwordResetMessage !== undefined) {
      document.title = `${this.translations(this.state.darkTitleBarJson.static_text_darkTitleBar.createPassword)} - ${'HSBC GLCM'}`;
      return (
        <div className="gdoc-first-time-user">
          <div className="gdoc-first-time-user-child">
            <div className="form-container">
              {/*<div className="form-title">
                <h2 className="form-heading">{pageTitle}</h2>
              </div>*/}
              {
                this.state.pwdNotMatch ? (
                  <div className="gdoc-confirm-pwd-error input-error-msg-section">
                    <span className="icon icon-circle-delete-solid"></span>{this.translations(this.state.formJson.par.static_text_confirmPassword.text)}
                  </div>
                ) : ''
              }
              {this.renderFormGroups()}
            </div>
          </div>
          <Modal
            show={this.state.showPassWordResetInfoModal}
            onClose={this.closePasswordResetModal}
            bsClass="delete-group-model"
          >
            <ModalBody>
              {this.translations(this.state.passwordResetMessage.static_text_documentation.description)}
            </ModalBody>
            <ModalFooter>
              <div className="delete-group-model--body">
                <div className="gdocs-float-left">
                  <button className="gdocs-btn-primary" onClick={this.togglePassWordResetInfoModal}>
                    {this.translations(this.state.passwordResetMessage.static_text_documentation.OkbuttonText)}
                  </button>
                </div>
              </div>
            </ModalFooter>
          </Modal>
          <div className="gdoc-first-time-user-hint" id="hints">
            <h2 className="gdoc-pwd-hint-head">{this.translations(pageTitle)}</h2>
            <ul>
              <li className="gdoc-pwd-hint">{this.translations(pwdhint1)}</li>
              <li className="gdoc-pwd-hint">{this.translations(pwdhint2)}</li>
              <li className="gdoc-pwd-hint">{this.translations(pwdhint3)}</li>
              <li className="gdoc-pwd-hint">{this.translations(pwdhint4)}</li>
              <li className="gdoc-pwd-hint">{this.translations(pwdhint5)}</li>
            </ul>
          </div>
        </div>
      );
    } else {
      return null
    }
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logInUser: (...args) => {
      dispatch(logInUser(...args));
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    },
    setHeaderDetails: (...args) => {
      dispatch(setHeaderDetails(...args))
    },
    setTranslatedData: translatedData => {
      dispatch(setTranslatedData(translatedData))
    },
    getDarkTitleBarFlagOnPassword: flag => {
      dispatch(getDarkTitleBarFlagOnPassword(flag));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FirstTimeUserCreateNewPassword);



// WEBPACK FOOTER //
// ./src/components/Login/FirstTimeUserCreateNewPassword.js